'use client';

import { Fragment } from 'react';

import Portal from '@mui/material/Portal';
import { styled } from '@mui/material/styles';

import { AnimateLogoZoom } from '../animate';

// ----------------------------------------------------------------------

/**
 * 전체 화면 로딩 표시. 기본은 포털로 띄우고, `portal={false}`면 제자리에 그린다.
 *
 * ⚠️ `slotProps`·`sx` 는 **선택이다** — 좁히면 `<SplashScreen />` 한 줄만 쓰는 호출부가
 * 막힌다. 통과 프롭(`...other`)이 있으므로 색인 서명도 연다.
 */
export type SplashScreenProps = {
  portal?: boolean;
  slotProps?: { wrapper?: any };
  sx?: any;
} & Record<string, any>;

export function SplashScreen({ portal = true, slotProps, sx, ...other }: SplashScreenProps) {
  const PortalWrapper = portal ? Portal : Fragment;

  return (
    <PortalWrapper>
      <LoadingWrapper {...slotProps?.wrapper}>
        <LoadingContent sx={sx} {...other}>
          <AnimateLogoZoom />
        </LoadingContent>
      </LoadingWrapper>
    </PortalWrapper>
  );
}

// ----------------------------------------------------------------------

const LoadingWrapper = styled('div')({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
});

const LoadingContent = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 9998,
  flexGrow: 1,
  width: '100%',
  height: '100%',
  display: 'flex',
  position: 'fixed',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.vars.palette.background.default,
}));
